import * as actionTypes from "../actions/actionTypes";
const initialState = {
	errors: [],
};

export default function validationReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.UPDATE_FORM_ERRORS:
			return Object.assign({}, state, { errors: action.errors });
		default:
			return state;
	}
}
